export default {
    mounted() {
        let that = this;

        document.addEventListener('keyup', function (evt) {
            var code;

            if (evt.key !== undefined) {
                code = evt.key;
            } else if (evt.keyIdentifier !== undefined) {
                code = evt.keyIdentifier;
            } else if (evt.keyCode !== undefined) {
                code = evt.keyCode;
            }
            
            if (code == 16 || code == "Shift") {
                that.shiftKeyUp();
            }
        });

        
        document.addEventListener('keydown', function (evt) {
            if (evt.shiftKey) {
                that.shiftKeyDown();
            }
        });

    },
};